import { render, staticRenderFns } from "./CartItemTax.vue?vue&type=template&id=d611a440"
import script from "./CartItemTax.vue?vue&type=script&lang=js"
export * from "./CartItemTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports